<script>
import { propertyComputed } from '@state/helpers'

export default {
  props: {
    ratePlan: { type: Object, required: true },
    room: { type: Object, required: true },
  },
  computed: {
    ...propertyComputed,
  },
}
</script>

<template>
  <div>
    <div class="px-3 my-3 text-center">
      <div class="text-xl">
        <div class="inline-block">
          <template v-if="ratePlan.occupancy.included > 2">
            <span>{{ ratePlan.occupancy.included }} x</span>
            <BaseIcon class="mx-1" name="male" />
          </template>

          <template v-else>
            <BaseIcon
              v-for="adult in 2"
              :key="adult"
              class="mx-1"
              name="male"
            />
          </template>
        </div>

        <div v-if="ratePlan.occupancy.extraBeds" class="inline-block">
          <span>{{
            ratePlan.occupancy.extraBeds > 1
            ? `+ ${ratePlan.occupancy.extraBeds} x`
            : '+'
          }}</span>
          <BaseIcon class="mx-1 text-sm" name="child" />
        </div>
      </div>

      <div class="mt-2 text-sm leading-tight">
        1 kid under
        {{ property.policy.maximumInfantAge + 1 }} years stays
        <span class="block font-medium text-green-600 uppercase">
          free
        </span>
      </div>
    </div>
  </div>
  <!-- occupancy column -->
</template>
